import { currencyFormatter } from "../api/Functions";
import { TypeAbonnement } from "./constants/account";

export function monthsToRecurrence(months) {
  switch (months) {
    case 1:
      return { by: "par mois", recurrence: "mensuel" };
    case 12:
      return { by: "par an", recurrence: "annuel" };
    default:
      return "";
  }
}

export function getAbonnementDetails(price, typeAbonnement, nbBiens, promos) {
  let rate = "";
  let rateInt = "";
  let rateDec = "";
  let name = "";
  let desc = "";
  let { by, recurrence } = monthsToRecurrence(price?.months);
  if (typeAbonnement === TypeAbonnement.TRIAL) {
    return {
      name: "Essai gratuit",
      desc: "Biens illimités",
    };
  }
  if (!price) return {};

  let unitAmountReduction = price.unit_amount;
  let hasReduction = false;
  for (let promo of Object.values(promos ?? {})) {
    if (promo.type === "discount" && promo.repetitions > 0) {
      hasReduction = true;
      unitAmountReduction -= promo.reduction_amount;
    }
  }

  const rawRate = price.unit_amount / 100;
  const unitAmountStr = price.unit_amount.toString();
  rateInt = unitAmountStr.slice(0, unitAmountStr.length - 2);
  rateDec = unitAmountStr.slice(unitAmountStr.length - 2);
  rate = `${currencyFormatter(rawRate)} ${by}`;
  if (hasReduction) {
    rate = `${currencyFormatter(unitAmountReduction / 100)} puis ${rate}`;
  }

  switch (typeAbonnement) {
    case TypeAbonnement.EARLYBIRD:
      name = "Early Bird";
      desc = "Biens illimités";
      break;
    case TypeAbonnement.REGULAR:
    case TypeAbonnement.STANDARD:
      if (nbBiens >= 7) {
        name = "Rentier";
        desc = "Biens illimités";
      } else if (nbBiens === 1) {
        name = "Investisseur";
        desc = `${nbBiens} bien`;
      } else {
        name = "Investisseur";
        desc = `${nbBiens} biens`;
      }
      break;
    case TypeAbonnement.TRIAL:
      name = "Essai gratuit";
      desc = "Biens illimités";
      break;
    case TypeAbonnement.CUSTOM:
      name = price.product_description || "Personnalisé";
      desc = nbBiens === 1 ? `${nbBiens} bien` : `${nbBiens} biens`;
      break;
    default:
      return {};
  }
  return { name, desc, rate, recurrence, by, rateInt, rateDec };
}
